$(document).ready(function(){

	if ($('.js-gallery').length) {
		// Initialization
		(function ($) {
			$.fn.gallery = function (path) {
				var gb = $(this);
				var gbContent = $(this).find('.gallery__content');

				var mobileInfo = gb.find('div[data-info=mobile]');
				var tabletInfo = gb.find('div[data-info=tablet]');

				var aPrev = gb.find('a[data-action=left]');
				gb.find('a[data-action=left]').click(function(event) {
					event.preventDefault();

					if ($(this).hasClass('disabled')) {
						return;
					}

					gb.find('.gallery ul > li.is-active').prev().click();
				});

				var aNext = gb.find('a[data-action=right]');
				gb.find('a[data-action=right]').click(function(event) {
					event.preventDefault();
					if ($(this).hasClass('disabled')) {
						return;
					}

					gb.find('.gallery__nav ul > li.is-active').next().click();
				});

				gb.find('.gallery__nav ul > li').each(function () {
					// create preview
					var liElem = $(this);
					liElem.html('');

					var imgs = $(this).attr('data-img').split(',');
					var dataState = $(this).attr('data-state');

					var dataGroup = 'gb' + $(this).attr('data-group');
					var group = $('<div/>')
					group.attr('id', dataGroup);

					imgs.forEach(function(img, idx) {

						// navigation images
						var elemImg = $('<img></img>');
						elemImg.attr('src', path + 'nav/'+img);
						liElem.append(elemImg);

						// content images
						var contentImg = $('<img/>');
						contentImg.attr('src', path + 'thumb/'+img);
						group.append(contentImg);
					});

					gbContent.append(group);
					group.toggle(); // hide

					if (dataState == 'is-active') {
						liElem.addClass('is-active');
						group.toggle(); // show if active

						// inital actions state
						if (aNext){
							if (liElem.next().prop('tagName') != 'LI') {
								aNext.addClass('disabled');
							} else {
								aNext.removeClass('disabled');
							}
						}
						if (aPrev){
							if (liElem.prev().prop('tagName') != 'LI') {
								aPrev.addClass('disabled');
							} else {
								aPrev.addRemove('disabled');
							}
						}

						// init info
						var activeImageInfo = liElem.attr('data-img-info');
						if (mobileInfo) {
							if (activeImageInfo == 'mobile') {
								mobileInfo.addClass('is-active');
							} else {
								mobileInfo.removeClass('is-active');
							}
						}

						if (tabletInfo) {
							if (activeImageInfo == 'tablet') {
								tabletInfo.addClass('is-active');
							} else {
								tabletInfo.removeClass('is-active');
							}
						}
					}

					liElem.click(function() {
						// activate group

						gb.find('.gallery__nav ul > li').each(function () {
							$(this).removeClass('is-active');
						});

						gbContent.find('div').hide();

						var currentGroup = 'gb' + $(this).attr('data-group');
						$('#'+currentGroup).toggle();
						$(this).addClass('is-active');

						if (aNext){
							if ($(this).next().prop('tagName') != 'LI') {
								aNext.addClass('disabled');
							} else {
								aNext.removeClass('disabled');
							}
						}
						if (aPrev){
							if ($(this).prev().prop('tagName') != 'LI') {
								aPrev.addClass('disabled');
							} else {
								aPrev.removeClass('disabled');
							}
						}

						// refresh info
						var currentImageInfo = $(this).attr('data-img-info');
						if (mobileInfo) {
							if (currentImageInfo == 'mobile') {
								mobileInfo.addClass('is-active');
							} else {
								mobileInfo.removeClass('is-active');
							}
						}

						if (tabletInfo) {
							if (currentImageInfo == 'tablet') {
								tabletInfo.addClass('is-active');
							} else {
								tabletInfo.removeClass('is-active');
							}
						}

					});
				});
			}

			/*Init*/
			$('.js-gallery').gallery('/static/prj/images/trimp4/screen/');
		})(jQuery);
	}

});